module.exports = __webpack_public_path__ + "static/media/train_53.903c7cf5.jpg";